<template>
  <div
    :id="packageDomID"
    class="packageListItemContainer"
    :class="{ active : isSelected }"
    :data-automation="automationID"
    @click="handleClick"
  >
    <div class="packageListItemHeader">
      <div class="name">
        {{ packageItem.name }}
      </div>
      <div class="version">
        {{ packageItem.version }}
      </div>
    </div>
    <div class="packageListItemDescription">
      {{ packageItem.info.summary }}
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import * as types from '../../store/mutation-types'
import { helpers } from '../../api/http-common'

export default {
  name: 'PackageListItem',
  props: {
    packageItem: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      selected: false,
    }
  },
  computed: {
    ...mapState({
      currentRepoId: state => state.repos.currentRepoId,
      selectedPackage: state => state.packages.selectedPackage,
    }),
    ...mapGetters([
      'getDocument',
    ]),
    isSelected: function () {
      if (this.selectedPackage) {
        return this.selectedPackage.id === this.packageItem.id
      } else {
        return false
      }
    },
    automationID: function () {
      return `package-link-${this.packageItem.id}`
    },
    packageDomID: function () {
      return `e2e-package-${this.packageItem.id}`
    },
  },
  methods: {
    ...mapActions([
      'getPackage',
      'getPackageVersions',
    ]),
    handleClick: function (event) {
      if (this.packageItem.id === this.selectedPackage.id) {
        return
      }
      this.$store.commit(types.SET_SELECTED_PACKAGE, this.packageItem)
      this.$store.commit(types.SET_SELECTED_PACKAGE_VERSION, '')
      this.$store.commit(types.SET_SELECTED_PACKAGE_RELEASE_DISTRIBUTIONS, undefined)

      this.getPackage({ repoId: this.currentRepoId, name: this.selectedPackage.name, id: this.selectedPackage.id })

      const main = this.getDocument.getElementById('main')
      main.scrollTop = 0
      main.scrollLeft = 0
      const basePath = helpers.basePath(window)
      helpers.pushURL(this.selectedPackage.name, `${basePath}client/#/repos/${this.currentRepoId}/packages/${this.selectedPackage.name}`)
    },
  },
}

</script>
